import fetcher from '../utils/api';

const auditService = {
  getAuditLogsForTeam: async (teamId, url, sortParam) => {
    let auditLogUrl = url;

    if (!auditLogUrl) {
      auditLogUrl = `audit_log/organization/${teamId}/`;
    }

    if (sortParam) {
      auditLogUrl += `?sort_by=${sortParam}`;
    }

    return fetcher(auditLogUrl, 'GET', true, {});
  },
  getAuditLogsForSuperOrganization: async (superOrganizationId, url, sortParam) => {
    let auditLogUrl = url;

    if (!auditLogUrl) {
      auditLogUrl = `audit_log/super_organization/${superOrganizationId}/`;
    }

    if (sortParam) {
      auditLogUrl += `?sort_by=${sortParam}`;
    }

    return fetcher(auditLogUrl, 'GET', true, {});
  }
};

export default auditService;
